import { DestinationTypes } from "@/enums/destinationTypes";
interface ZoomByCategory {
  (category?: DestinationTypes): number;
}

const zoomByCategory: ZoomByCategory = (category) => {
  if (!category) return 0;

  switch (category) {
    case DestinationTypes.place:
      return 14;
    case DestinationTypes.poi:
      return 15;
    case DestinationTypes.neighborhood:
      return 17;

    default:
      return 14;
  }
};

export default zoomByCategory;
